import React from "react";

import FurtherReadingListArticleItem from "./further-reading-list-article-item";
import FurtherReadingListBookItem from "./further-reading-list-book-item";
import FurtherReadingListChapterItem from "./further-reading-list-chapter-item";
import FurtherReadingListNoteItem from "./further-reading-list-note-item";

class FurtherReadingListItem extends React.Component {
  render() {
    switch (this.props.item.data.Type) {
      case 'Book':
        return (<FurtherReadingListBookItem item={this.props.item} />);
      case 'Article':
        return (<FurtherReadingListArticleItem item={this.props.item} />);
      case 'Chapter':
        return (<FurtherReadingListChapterItem item={this.props.item} />);
      case 'Note':
        return (<FurtherReadingListNoteItem item={this.props.item} />);
      default:
        return null;
    }
  }
}

export default FurtherReadingListItem;